import {Controller} from 'react-hook-form';
import {TextField} from '@mui/material';

const TextFieldController = ({
  name,
  control,
  label,
  required,
  errors,
  onChange,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    // rules={{required: true, minLength: 5, maxLength: 20}}
    render={({field: {ref, onChange: _onChange, ...field}, fieldState}) => (
      <TextField
        {...field}
        label={label}
        required={required}
        inputRef={ref}
        error={errors.hasOwnProperty(name) && !!errors[name]}
        helperText={
          errors.hasOwnProperty(name)
            ? errors[name]['message']
            : required
            ? field.value.trim() === '' && fieldState.isDirty
              ? 'Requerido'
              : ' '
            : null
        }
        variant="standard"
        fullWidth
        {...rest}
        onChange={({target: {value}}) => {
          _onChange(value);

          if (onChange) {
            onChange(value);
          }
        }}
      />
    )}
  />
);

export default TextFieldController;
